import * as i0 from '@angular/core';
import { Directive, Attribute, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';

class ngxInputRegulateReactive {
    constructor(pattern, control) {
        this.control = control;
        this.regExpattern = new RegExp(pattern);
    }
    onInputChange(event) {
        var _a;
        var test = this.regExpattern.test(event.target.value);
        if (test) {
            event.target.defaultValue = event.target.value;
        }
        else {
            (_a = this.control.control) === null || _a === void 0 ? void 0 : _a.setValue(event.target.defaultValue);
        }
    }
}
ngxInputRegulateReactive.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ngxInputRegulateReactive, deps: [{ token: 'ngxir-pattern', attribute: true }, { token: i1.NgControl }], target: i0.ɵɵFactoryTarget.Directive });
ngxInputRegulateReactive.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.0.5", type: ngxInputRegulateReactive, selector: "[ngxInputRegulate]", host: { listeners: { "input": "onInputChange($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ngxInputRegulateReactive, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngxInputRegulate]'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Attribute,
                    args: ['ngxir-pattern']
                }] }, { type: i1.NgControl }]; }, propDecorators: { onInputChange: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

class ngxInputRegulateModule {
}
ngxInputRegulateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ngxInputRegulateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ngxInputRegulateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ngxInputRegulateModule, declarations: [ngxInputRegulateReactive], exports: [ngxInputRegulateReactive] });
ngxInputRegulateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ngxInputRegulateModule, providers: [], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.0.5", ngImport: i0, type: ngxInputRegulateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ngxInputRegulateReactive,
                    ],
                    imports: [],
                    exports: [ngxInputRegulateReactive],
                    providers: [],
                    bootstrap: []
                }]
        }] });

/*
 * Public API Surface of ngx-input-regulate
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ngxInputRegulateModule, ngxInputRegulateReactive };
